import React from 'react'
import { Button as MuiButton, Typography, styled } from '@mui/material'
import { convertToKebabCase } from '../../../utils/utils'
import {
  BaseComponentProps,
  ButtonProps
} from './Ui'

const ButtonWrapper = styled('div')<BaseComponentProps>(
  ({ theme, spacingBottomDesktop, spacingBottomMobile }) => ({
    marginBottom: spacingBottomMobile,
    [theme.breakpoints.up('md')]: {
      marginBottom: spacingBottomDesktop
    }
  })
)

const ThemeButton = ({
  content,
  url,
  theme = 'light',
  variant = 'contained',
  subText,
  subTextColour,
  openInNewTab,
  spacingBottomDesktop,
  spacingBottomMobile,
  idSuffix,
  handleOnClick
}: ButtonProps) => {
  /**
   * handleOnClick is optional, but provides a way to over-ride the href passed.
   * This might be used in a react application when you want to specific functionality to happen from within the parent method instead of navigating to a URL.
   */
  const handleButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    if (handleOnClick) {
      event.preventDefault()
      handleOnClick(event)
    }
  }

  const tagId = `tag_${convertToKebabCase(content)}-${idSuffix}`

  return (
    <ButtonWrapper
      spacingBottomDesktop={spacingBottomDesktop}
      spacingBottomMobile={spacingBottomMobile}
    >
      <MuiButton
        variant={variant}
        className={theme}
        aria-label={convertToKebabCase(content)}
        id={tagId}
        data-testid={tagId}
        href={url ? url : ''}
        target={openInNewTab ? '_blank' : '_self'}
        onClick={handleButtonClick}
      >
        {content}
      </MuiButton>
      {subText && (
        <Typography
          align="center"
          maxWidth="20.375rem"
          dangerouslySetInnerHTML={{ __html: subText }}
          color={subTextColour}
          mt={4}
          variant="titleSmall"
          component="p"
          fontWeight={500}
        ></Typography>
      )}
    </ButtonWrapper>
  )
}

export default ThemeButton
